const routingGetter = (state) => state.routing;

export const routingSelector = (state) => ({
  routing: routingGetter(state)
});
